<template>
  <div class="site-page">
    <div class="row" v-if="isNotMobileScreen == true">
      <div class="col-md-12 page-title">
        <div class="row">
          <div class="col-md-9">
            <h1>
              Résultats de la recherche:
              <span class="ml-1 text-muted"> "{{ $route.query.value }}" </span>
            </h1>
            <p class="text-muted" v-if="onloading == false">
              <b>{{ search_results.length }}</b> résultat{{
                search_results.length > 1 ? "s" : ""
              }}
              pour cette recherche
            </p>
            <div
              class="d-flex align-items-center justify-content-center empty"
              v-if="onloading == true"
            >
              <b-spinner></b-spinner>
            </div>
            <div v-else-if="onloading == false">
              <div v-if="search_results.length == 0">
                Auncun résultat trouvé
              </div>
              <div v-else-if="search_results.length > 0">
                <div
                  v-for="(r, index) in search_results"
                  :key="index"
                  @click="action(r)"
                >
                  <div
                    class="
                      card-box
                      py-4
                      mb-3
                      d-flex
                      align-items-center
                      justify-content-between
                      flex-wrap
                    "
                  >
                    <div>
                      <h6 class="marker">{{ r.title }}</h6>
                      <div class="marker mb-2">
                        {{ r.description }}
                      </div>
                    </div>
                    <a
                      class="btn btn-secondary ripple mb-2"
                      href="#"
                      @click="action(r)"
                    >
                      <i class="mdi mdi-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="" class="col-md-3">
            <InfoSimWidget />
            <OtherSimWidget />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="isNotMobileScreen == false">
      <div class="col-md-12 page-title mb-4 d-flex align-items-center">
        <div class="input-group w-100 mb-3 position-relative">
          <input
            type="text"
            class="form-control"
            placeholder="Rechercher un service"
            v-model="search_model"
          />
          <button
            class="btn search-button d-flex align-items-center text-center"
            type="button"
            @click="searchSomething"
          >
            <i class="search-icon kgk-mtn-search w-100"></i>
          </button>
        </div>
      </div>
      <div class="w-100" id="content-search">
        <div
          class="d-flex align-items-center justify-content-center empty"
          v-if="onloading == true"
        >
          <b-spinner></b-spinner>
        </div>
        <div v-else-if="onloading === false">
          <div v-if="search_results.length == 0">Auncun résultat trouvé</div>
          <b-row v-else-if="search_results.length > 0" class="d-block px-3">
            <b-col
              v-for="(r, index) in search_results"
              :key="index"
              @click="action(r)"
              md="12"
              lg="6"
              class="
                card-box
                py-4
                mb-3
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
              "
            >
              <div>
                <h6 class="marker">{{ r.title }}</h6>
                <div class="mb-2 marker">
                  {{ r.description }}
                </div>
              </div>
              <a
                class="btn btn-secondary ripple mb-2"
                href="#"
                @click="action(r)"
              >
                <i class="mdi mdi-arrow-right"></i>
              </a>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InfoSimWidget from "@/components/home/InfoSimWidget";
import OtherSimWidget from "@/components/home/OtherSimWidget";
import Fuse from "fuse.js";
export default {
  components: { InfoSimWidget, OtherSimWidget },
  data() {
    return {
      onloading: null,
      search_results: [],
      search_model: "",
      availables: [],
      search_options: {
        includeScore: true,
        keys: ["title", "description"],
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    if (window.screen.availWidth >= 600) {
      if (to.query.value && to.query.value !== "") {
        next();
      } else {
        next({ name: "home" });
      }
    } else {
      next();
    }
  },
  created() {
    this.availables = [
      ...this.$store.state.configs.services_list,
      ...this.$store.state.configs.sim_services,
    ];
    if (this.isNotMobileScreen) {
      this.onloading = true;
      this.searchSomething();
    }
  },
  mounted() {},
  methods: {
    action: function (element) {
      if (element.action !== "") {
        var self = this;
        setTimeout(() => {
          self.open_modal(element.action);
        }, 100);
      } else if (element.extern_link == true) {
        window.open(`${element.url}`, "_blank");
      }
    },
    searchSomething() {
      this.onloading = true;
      setTimeout(() => {
        this.onloading = false;
        this.search_results = this.availables.filter(
          (element) =>
            element.title
              .toLowerCase()
              .includes(this.$store.state.core.current_search.toLowerCase()) ||
            element.description
              .toLowerCase()
              .includes(this.$store.state.core.current_search.toLowerCase())
        );
      }, 1000);
    },
  },
  computed: {
    isNotMobileScreen() {
      if (window.screen.availWidth >= 600) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    search_model() {
      this.$store.state.core.current_search = search_model;
    },
    async "$route.query.value"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.searchSomething();
      }
    },
    "$store.state.core.current_search"() {
      this.searchSomething();
    },
  },
};
</script>
<style scoped>
.empty {
  padding-top: 100px !important;
  padding-bottom: 100px !important;
}
.btn.ripple {
  background: transparent !important;
  border: none;
  color: #106887;
}
.btn.ripple i {
  font-size: 18px !important;
}
h6 {
  font-weight: 700 !important;
}
.card-box {
  cursor: pointer !important;
}
input {
  height: 36px;
  border-right: none !important;
  border: 1px solid #6c757d !important;
  border-radius: 20px !important;
  padding-right: 0;
  padding-right: 38px !important;
  width: calc(100%) !important;
  border-right: none !important;
  box-sizing: border-box !important;
}
.search-button,
.search-button:hover,
.search-button:active {
  height: 36px !important;
  width: 36px !important;
  padding: 0 !important;
  border: 1px solid #6c757d !important;
  border-left: 1px solid transparent;
  margin-left: -18px !important;
  position: absolute;
  right: 0;
  top: 0 !important;
  background-color: #fc0 !important;
  z-index: 1000 !important;
}
.search-icon {
  font-size: 18px !important;
}
</style>